
import BRadioButton from 'JS/components/blain-form/BRadioButton.vue';
import BRadioGroup from 'JS/components/blain-form/BRadioGroup.vue';
import GlobalData from 'JS/global/window-data';
import Icon from 'Src/js/components/Icon.vue';
import LinkButton from 'JS/components/LinkButton.vue';
import TransitionExpand from 'JS/components/transitions/TransitionExpand.vue';
import Vue from 'vue';
import { BSelect } from 'JS/components/blain-form';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { FulfillmentType } from '../../../types/ProductDelivery';
import { Get } from 'vuex-pathify';
import { IEligibleSubscriptionResource, IPendingSubscriptionResource, ProductSubscriptionStatus } from 'JS/types/Order';
import { ILocalStoreJson } from '../../../types/LocalStore';
import { IProductDetailProductJson } from 'JS/types/PDP';

@Component({
	name: 'InStorePickup',
	components: {
		BRadioButton,
		BRadioGroup,
		BSelect,
		Icon,
		LinkButton,
	}
})
export default class SubscriptionOptions extends Vue {

	/* Computed
	============================================*/
	@Prop({ type: String })
	readonly currentFrequencySelection: string;

	@Prop({ type: Boolean, required: false, default: false })
	readonly loading: boolean;

	@Get('localStore')
	readonly localStore: ILocalStoreJson;

	@Get('product')
	readonly product: IProductDetailProductJson;

	@Get('isPickupDisabled')
	readonly isPickupDisabled: boolean;

	@Get('hasSelectedVariant')
	readonly hasSelectedVariant: boolean;

	@Get('quantity')
	readonly quantity: number;

	get outOfMarket(): boolean {
		return !this.localStore;
	}

	get currentSubscriptionSelection() {
		return this.subscriptionSelection;
	}

	set currentSubscriptionSelection(newSelection: FulfillmentType.InStorePickup | 'Subscription') {
		this.subscriptionSelection = newSelection;
		this.$emit('change', FulfillmentType.InStorePickup);
	}

	get subFrequencySelection(): string {
		return this.currentFrequencySelection;
	}

	set subFrequencySelection(newVal: string) {
		this.$emit('update:currentFrequencySelection', newVal);
	}

	get isDisabled() {
		return this.outOfMarket || this.isPickupDisabled || !this.hasSelectedVariant || this.loading;
	}

	get isRewardsMember() {
		return GlobalData.customer?.isRewardsMember;
	}

	get subscriptionInfo(): IEligibleSubscriptionResource | IPendingSubscriptionResource | null {
		if (this.product.subscriptionInfo.status === ProductSubscriptionStatus.Eligible
			|| this.product.subscriptionInfo.status === ProductSubscriptionStatus.Pending) {
			return this.product.subscriptionInfo ;
		}
		return null;
	}

	get inStorePickup() {
		return FulfillmentType.InStorePickup;
	}

	get fulfillmentRadioName(): string {
		return `fulfillment-${this.product.blainNumber}`;
	}

	/* Data
	============================================*/
	subscriptionSelection: FulfillmentType.InStorePickup | 'Subscription' = null;
	prevFrequencySelection: string = "";
	/* Methods
	============================================*/

	farmsBenefitLineItem(str: string, substr: string, adjustWithQty?: boolean): string {
		let finalStr = substr;
		if (adjustWithQty) {
			finalStr = (parseFloat(substr) * this.quantity).toFixed(2);
		}
		return str.replaceAll(substr, `<strong>${finalStr}</strong>`);
	}

	/* Lifecycle Hooks
	============================================*/

	created() {
		if (this.isDisabled) {
			return;
		}
		if (this.subscriptionInfo.status === ProductSubscriptionStatus.Pending) {
			this.subscriptionSelection = 'Subscription';
		} else {
			this.subscriptionSelection = FulfillmentType.InStorePickup;
		}
	}

	/* Watchers
	============================================*/
	@Watch('subscriptionSelection')
	onSubscriptionSelectionChange(currentSubscriptionSelection: string) {
		if (currentSubscriptionSelection !== 'Subscription') {
			this.prevFrequencySelection = this.subFrequencySelection;
			this.subFrequencySelection = "";
		} else {
			if (this.prevFrequencySelection) {
				this.subFrequencySelection = this.prevFrequencySelection;
			} else {
				this.subFrequencySelection = this.subscriptionInfo.frequency.toString();
			}
		}
	}
}
